function Directive() {
  return {
    restrict: 'E',
    template: `<div class="venue-type">
      <span>{{:: venue.type }}</span>
      <span ng-show="venue.subtype"> | {{:: venue.subtype }}</span>
      <span ng-show="venue.location.neighborhood"> in {{:: venue.location.neighborhood }}</span>
    </div>`,
    replace: true,
    scope: {
      venue: '='
    }
  };
}

Directive.$inject = [];

export default Directive;



// WEBPACK FOOTER //
// ./src/directives/venueType/index.js